import { Outlet } from 'react-router'
import { Footer } from './Footer'
import { Navbar } from './Navbar'

export const MainLayout = () => (
  <div
    style={{
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column',
      background: '#fdfaf5',
      color: '#1a1510',
    }}
  >
    <Navbar />
    <main style={{ flex: 1, paddingTop: '76px' }}>
      <Outlet />
    </main>
    <Footer />
  </div>
)
